import { Autocomplete, type AutocompleteChangeReason, Box, TextField } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { type Country } from 'services'
import { useCountriesLuts } from '../common/hooks/use-luts-hook'

export interface CountrySelectorProps {
  filters: any
  handleCountryChange: (country: Country | null) => void
}
export const CountrySelector: React.FC<CountrySelectorProps> = ({ filters, handleCountryChange }) => {
  const { lutValues: countriesLutValues } = useCountriesLuts()
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null)
  const [inputValue, setInputValue] = useState('')

  const countryById = useMemo(() => {
    const dictionary = new Map<number, Country>()
    Array.from(countriesLutValues.countries).forEach((country) => {
      dictionary.set(country.id, country)
    })
    return dictionary
  }, [countriesLutValues.countries])
  const countryByName = useMemo(() => {
    const dictionary = new Map<string, Country>()
    Array.from(countriesLutValues.countries).forEach((country) => {
      dictionary.set(country.country_desc, country)
    })
    return dictionary
  }, [countriesLutValues.countries])

  useEffect(() => {
    let selectedCountry = null
    if (filters.country !== null) {
      selectedCountry = countryById.get(filters.country) ?? null
    } else if (filters.country_name !== null) {
      selectedCountry = countryByName.get(filters.country_name) ?? null
    }
    if (selectedCountry === null) {
      filters.country = null
      filters.country_name = null
    }
    setSelectedCountry(selectedCountry)
  }, [countryById, countriesLutValues.countries, filters.country, filters.country_name, filters.parent_orgs])

  const handleInputChange = (event: React.ChangeEvent<any>, value: string): void => {
    setInputValue(value)
    if (event !== null) {
      filters.parent_orgs = []
    }
  }

  const handleCountrySelection = (event: React.ChangeEvent<any>, value: Country | null, _reason: AutocompleteChangeReason): void => {
    setSelectedCountry(value)
    handleCountryChange(value)
  }

  return (
    <div>
      <Autocomplete
        id="country-select-demo"
        options={countriesLutValues.countries}
        getOptionLabel={(option) => option.country_desc}
        renderOption={(props, option) => (
          <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
            {option.country_desc}
          </Box>
        )}
        value={selectedCountry}
        onChange={handleCountrySelection}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        autoHighlight
        renderInput={(params) => (
          <TextField
            {...params}
            label="Choose a country"
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password' // disable autocomplete and autofill
            }}
          />
        )}
      />
    </div>
  )
}
